// Lovable Cloud App
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "./pages/Landing";
import LandingComplete from "./pages/LandingComplete";
import BlogOverview from "./pages/BlogOverview";
import BlogArticle from "./pages/BlogArticle";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Dashboard from "./pages/Dashboard";
import Auth from "./pages/Auth";
import Appointments from "./pages/Appointments";
import Chat from "./pages/Chat";
import AppointmentSuccess from "./pages/AppointmentSuccess";
import KlartechKompakt from "./pages/KlartechKompakt";
import KompaktHistory from "./pages/KompaktHistory";
import Gutschein from "./pages/Gutschein";
import GutscheinErfolg from "./pages/GutscheinErfolg";
import ChatWidget from "./components/ChatWidget";
import { Toaster } from "./components/ui/toaster";
import "./App.css";

// Component to conditionally render ChatWidget
const ChatWidgetWrapper = () => {
  const location = useLocation();
  // Don't show on dashboard, auth, chat, or kompakt pages
  const hiddenPaths = ['/dashboard', '/auth', '/chat', '/kompakt'];
  const shouldHide = hiddenPaths.some(path => location.pathname.startsWith(path));
  
  if (shouldHide) return null;
  return <ChatWidget />;
};

function AppContent() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingComplete />} />
        <Route path="/landing-full" element={<Landing />} />
        <Route path="/blog" element={<BlogOverview />} />
        <Route path="/blog/:articleId" element={<BlogArticle />} />
        <Route path="/termine" element={<Appointments />} />
        <Route path="/termin" element={<Appointments />} />
        <Route path="/appointment-success" element={<AppointmentSuccess />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/kompakt" element={<KlartechKompakt />} />
        <Route path="/kompakt/history" element={<KompaktHistory />} />
        <Route path="/gutschein" element={<Gutschein />} />
        <Route path="/gutschein-erfolg" element={<GutscheinErfolg />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/auth" element={<Auth />} />
      </Routes>
      <ChatWidgetWrapper />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;